<template>
  <div class="app-overview">
    <div class="app-overview__body">
      <div
        v-for="(group, groupIndex) in props.groups"
        :key="groupIndex"
        class="app-overview__group"
      >
        <span>
          {{ group.displayName }}
        </span>

        <div class="app-overview__group-body">
          <template v-if="loading">
            <PrmSkeleton
              v-for="item in 6"
              :key="item"
              height="60px"
            />
          </template>
          <template v-else>
            <AppTile
              v-for="(app, appIndex) in group.apps"
              :key="appIndex"
              v-bind="app"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';

import AppTile, {
  TAppTileProps,
} from '../app-tile/app-tile.vue';

export type TAppGroup = {
  displayName: string,
  apps: TAppTileProps[],
};
const props = defineProps<{
  groups: TAppGroup[] | undefined,
  loading?: boolean,
}>();
</script>

<style lang="scss" scoped>
.app-overview {
  padding: var(--gap-section);
  display: flex;
  flex-direction: column;
  gap: var(--gap-section);

  &__body {
    display: flex;
    flex-direction: column;
    gap: var(--gap-section);
  }

  &__header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--gap-section);
  }

  &__header-checkbox {
    display: flex;
    gap: 0.5rem;
  }

  &__group {
    display: flex;
    flex-direction: column;
    gap: var(--gap-section);

    span {
      color: var(--text-color);
      font-weight: bold;
    }
  }

  &__group-body {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: var(--gap-section);
  }
}
</style>
